import { PipelineProvider } from '../context';
import { PipelineHeader } from './PipelineLayout/PipelineHeader';
import { PipelineOverview } from './PipelineLayout/PipelineOverview';
import { PipelineBoard } from './PipelineBoard/PipelineBoard';
import { PipelineStage } from './PipelineBoard/PipelineStage';
import { PipelineCard } from './PipelineCard/PipelineCard';
import { TrashDropZone } from './PipelineBoard/TrashDropZone';
import { GlobalSearchResultsPanel } from './PipelineLayout/GlobalSearchResultsPanel';
import { PipelineLoadingSkeleton } from './PipelineLayout/PipelineLoadingSkeleton';

/**
 * Pipeline Compound Component
 *
 * Usage:
 * ```tsx
 * <Pipeline.Provider>
 *   <Pipeline.Header />
 *   <Pipeline.Overview />
 *   <Pipeline.TrashZone variant="compact" />
 *   <Pipeline.Board>
 *     {stages.map(stage => (
 *       <Pipeline.Stage key={stage.id} stage={stage} />
 *     ))}
 *   </Pipeline.Board>
 *   <Pipeline.TrashZone variant="full" />
 *   <Pipeline.SearchResults {...searchProps} />
 * </Pipeline.Provider>
 * ```
 *
 * Or use the default Board which renders stages automatically:
 * ```tsx
 * <Pipeline.Provider>
 *   <Pipeline.Header />
 *   <Pipeline.Overview />
 *   <Pipeline.TrashZone variant="compact" />
 *   <Pipeline.Board />
 *   <Pipeline.TrashZone variant="full" />
 * </Pipeline.Provider>
 * ```
 */
const Pipeline = {
  // Provider - wraps all pipeline components and provides context
  Provider: PipelineProvider,

  // Layout components
  Header: PipelineHeader,
  Overview: PipelineOverview,

  // Board components
  Board: PipelineBoard,
  Stage: PipelineStage,
  Card: PipelineCard,

  // Utility components
  TrashZone: TrashDropZone,
  SearchResults: GlobalSearchResultsPanel,
  LoadingSkeleton: PipelineLoadingSkeleton,
};

export default Pipeline;

// Named exports for direct imports
export {
  PipelineProvider,
  PipelineHeader,
  PipelineOverview,
  PipelineBoard,
  PipelineStage,
  PipelineCard,
  TrashDropZone,
  GlobalSearchResultsPanel,
  PipelineLoadingSkeleton,
};
